export default __webpack_public_path__ + "static/media/BOD Regular Meeting 12 May 2021.7bcaf963.pdf";